import React from "react";
import { useI18next } from 'gatsby-plugin-react-i18next';
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./style.module.scss";

const { 
  bookACall,
  bookACall__content,
  bookACall__text,
  bookACall__btn,
} = styles;

const BookACallCTA = () => {
  const { language } = useI18next();

  const url =
    language === "de"
    ? 'https://www.dealfront.com/de/request-demo/'
    : 'https://www.dealfront.com/request-demo/';
    
    const btnText = 
    language === "de"
      ? "Buchen Sie einen Anruf"
      : "Book a call";

    const descText = 
    language === "de"
      ? "Unser Team kann Ihnen helfen, die richtige Lösung für Ihr Unternehmen auszuwählen"
      : "Our Team can help you pick the right solution for your business";

  return (
    <div className={bookACall}>
      {language === 'de' ? (
        <StaticImage
          placeholder="none"
          src="../../../../images/cta/book-a-call.png"
          alt="Banner Book a call"
        />
      ) : (
        <StaticImage
          placeholder="none"
          src="../../../../images/cta/book-a-call.png"
          alt="Banner Book a call"
        />
      )}
      <div className={bookACall__content}>
        <div className={bookACall__text}>{descText}</div>
        <a href={url} className={bookACall__btn}>
          {btnText}
        </a>
      </div>
    </div>
  );
};

export default BookACallCTA;
